<svg class="icon-context" [class.active]="isActive" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
    viewBox="0 0 16 16" fill="none">
    <path
        d="M15.5 13.5V3.5C15.5 2.94772 15.0523 2.5 14.5 2.5H1.5C0.947715 2.5 0.5 2.94772 0.5 3.5V13.5C0.5 14.0523 0.947715 14.5 1.5 14.5H14.5C15.0523 14.5 15.5 14.0523 15.5 13.5Z"
        stroke="var(--text-color-dark)" />
    <path d="M2.5 4.5L7.46312 7.65835C7.79069 7.8668 8.20931 7.8668 8.53688 7.65835L13.5 4.5"
        stroke="var(--text-color-dark)" stroke-linecap="round" />
</svg>
